import { useEffect } from "react";

import { useApiNfeFadel } from "./useAPI";

import { useAuth } from "context/AuthContext";
import { useAPIToast } from "hooks/useAPIToast";

import useSWR from "swr";

export const useAPINfeFadel = () => {
  const api = useApiNfeFadel();

  const { onSend, isLoading, data } = useAPIToast(api);

  return {
    isLoading,
    data,
    onSend,
  };
};

export const useAPIFadelFetch = (url, axiosConfigs, config) => {
  const api = useApiNfeFadel();
  const { tokenCompanies, revalidateAll, setRevalidateAll } = useAuth();

  const { data, error, mutate, revalidate, isValidating } = useSWR(
    url,
    async urlReturn => {
      if (axiosConfigs?.method === "POST") {
        const response = await api.post(urlReturn, axiosConfigs.data);
        return response.data;
      }

      const response = await api.get(urlReturn, axiosConfigs);
      return response.data;
    },
    config,
  );

  // Revalida todas as requisicoes para carregar os dados corretamente!
  useEffect(() => {
    if (revalidateAll?.length && axiosConfigs?.method !== "POST") {
      revalidate();
      setRevalidateAll();
    }
  }, [
    tokenCompanies,
    revalidate,
    revalidateAll,
    setRevalidateAll,
    axiosConfigs?.method,
  ]);

  return {
    data,
    error,
    isError: !!error,
    isLoading: (!error && !data && String(data) !== "") || isValidating,
    isValidating,
    mutate,
    revalidate,
  };
};
